// Port de app/onboarding.tsx.
import { Carregando } from "@/app/Carregando";
import { lazy } from "react";

const OnboardingScreen = lazy(() => import("@/screens/Onboarding"));

export default function OnboardingRoute() {
  return (
    <Carregando cor="#294956">
      <OnboardingScreen />
    </Carregando>
  );
}
